import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { SnippetVerificationResult } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export type GetSnippetVerificationResultParams = {
  organizationId: string;
};

export const getSnippetVerificationResult = async (
  params: GetSnippetVerificationResultParams,
): Promise<SnippetVerificationResult> => {
  return await tinctApi.organizations.getSnippetVerificationResult(
    params.organizationId,
  );
};

export const useGetSnippetVerificationResult = (
  params: GetSnippetVerificationResultParams,
  options?: Omit<
    UseQueryOptions<SnippetVerificationResult, ApiError>,
    'queryKey'
  >,
) =>
  useQuery({
    queryKey: ['snippet-verification-result', params.organizationId],
    queryFn: () => getSnippetVerificationResult(params),
    ...options,
  });
